document.addEventListener("DOMContentLoaded", function () {
  const root = document.querySelector("#mimi-personalizer");
  if (!root || !window.MIMI_CONFIG) return;

  const mode = root.dataset.mode || "les_deux";
  const steps = Array.from(root.querySelectorAll(".mimi-accordion"));

  const techniqueChoices = root.querySelector("#mimi-technique-choices");
  const techniqueAuto = root.querySelector("#mimi-technique-auto");
  const techniqueValue = root.querySelector("#mimi-technique-value");

  const textInput = root.querySelector("#mimi-text-input");
  const textCount = root.querySelector("#mimi-text-count");

  const flowerValue = root.querySelector("#mimi-flower-value");

  const fontsContainer = root.querySelector("#mimi-fonts");
  const fontValue = root.querySelector("#mimi-font-value");

  const textColorsContainer = root.querySelector("#mimi-text-colors");
  const textColorValue = root.querySelector("#mimi-text-color-value");

  const symbolsContainer = root.querySelector("#mimi-symbols");
  const symbolValue = root.querySelector("#mimi-symbol-value");

  const symbolColorsContainer = root.querySelector("#mimi-symbol-colors");
  const symbolColorValue = root.querySelector("#mimi-symbol-color-value");

  let currentTechnique = null;

  function clearMimiErrors() {
    root.querySelectorAll(".mimi-field-error").forEach((error) => {
      error.remove();
    });
  }

  document.addEventListener("mimi:cart-added", function () {
    const toast = document.getElementById("mimi-toast");

    if (!toast) {
      console.error("Notification Mimi introuvable");
      return;
    }

    clearTimeout(window.mimiToastTimeout);

    toast.hidden = false;
    toast.classList.add("show");

    window.mimiToastTimeout = setTimeout(function () {
      toast.classList.remove("show");
      toast.hidden = true;
    }, 3000);
  });

  root.querySelectorAll(".mimi-error").forEach((step) => {
    step.classList.remove("mimi-error");
  });

  root.querySelectorAll('[aria-invalid="true"]').forEach((field) => {
    field.removeAttribute("aria-invalid");
  });

  function showMimiError(stepName, message, field = null) {
    const step = getStep(stepName);
    if (!step) return;

    step.classList.add("mimi-error");
    step.classList.add("active");

    const toggle = step.querySelector(".mimi-toggle");
    if (toggle) toggle.textContent = "−";

    const content = step.querySelector(".mimi-accordion-content");

    if (content) {
      const error = document.createElement("p");
      error.className = "mimi-field-error";
      error.textContent = "⚠️ " + message;
      content.prepend(error);
    }

    if (field) {
      field.setAttribute("aria-invalid", "true");
    }

    step.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });
  }

  function validateMimiPersonalization() {
    clearMimiErrors();

    if (!currentTechnique || !techniqueValue?.value) {
      showMimiError(
        "technique",
        "Veuillez choisir le flocage ou la broderie."
      );
      return false;
    }

    if (!textInput?.value.trim()) {
      showMimiError(
        "texte",
        "Veuillez saisir un prénom ou un mot.",
        textInput
      );
      textInput?.focus();
      return false;
    }

    const hasProductFont =
      typeof window.MIMI_PRODUCT_FONT === "string" &&
      window.MIMI_PRODUCT_FONT.trim() !== "";

    if (
      currentTechnique === "broderie" &&
      !flowerValue?.value &&
      !hasProductFont
    ) {
      showMimiError(
        "lettre-fleurie",
        "Veuillez choisir si vous souhaitez une lettre fleurie."
      );
      return false;
    }

    if (!fontValue?.value) {
      showMimiError(
        "police",
        "Veuillez choisir une police d’écriture."
      );
      return false;
    }

    if (!textColorValue?.value) {
      showMimiError(
        "couleur-texte",
        "Veuillez choisir la couleur du texte."
      );
      return false;
    }

    if (!hasProductFont && !symbolValue?.value) {
      showMimiError(
        "symbole",
        "Veuillez choisir un symbole."
      );
      return false;
    }

    if (
      !hasProductFont &&
      symbolValue?.value !== "Aucun symbole" &&
      !symbolColorValue?.value
    ) {
      showMimiError(
        "couleur-symbole",
        "Veuillez choisir la couleur du symbole."
      );
      return false;
    }

    return true;
  }

  window.validateMimiPersonalization =
    validateMimiPersonalization;

  function formatMimiPrice(cents) {
    return (cents / 100).toFixed(2).replace(".", ",") + " €";
  }

  function updateDisplayedPrice() {
    const basePrice = Number(root.dataset.basePrice || 0);
    if (!basePrice) return;

    const extra =
      currentTechnique === "broderie" ? 500 : 0;

    const finalPrice = basePrice + extra;

    const priceSelectors = [
      ".price-item--regular",
      ".price__regular .price-item",
      ".price .price-item",
      "price-list .price",
      ".product__price",
      ".price"
    ];

    priceSelectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        if (
          el.closest(".cart-drawer") ||
          el.closest(".cart")
        ) {
          return;
        }

        el.textContent =
          formatMimiPrice(finalPrice);
      });
    });
  }

  function getStep(name) {
    return root.querySelector(`[data-step="${name}"]`);
  }

  function forceOpenMainSteps() {
    ["technique", "texte"].forEach((name) => {
      const step = getStep(name);
      if (!step) return;

      step.classList.add("active");

      const toggle = step.querySelector(".mimi-toggle");
      if (toggle) toggle.textContent = "−";
    });
  }

  function openStep(name) {
    steps.forEach((step) => {
      const stepName = step.dataset.step;

      if (
        stepName === "technique" ||
        stepName === "texte"
      ) {
        return;
      }

      step.classList.remove("active");

      const toggle = step.querySelector(".mimi-toggle");
      if (toggle) toggle.textContent = "+";
    });

    const step = getStep(name);

    if (!step || step.style.display === "none") {
      forceOpenMainSteps();
      return;
    }

    step.classList.add("active");

    const toggle = step.querySelector(".mimi-toggle");
    if (toggle) toggle.textContent = "−";

    forceOpenMainSteps();
  }

  function completeStep(name) {
    const step = getStep(name);
    if (step) step.classList.add("completed");
  }

  function showStep(name, show) {
    const step = getStep(name);
    if (!step) return;

    step.style.display = show ? "" : "none";
  }

  function resetAfterTechnique() {
    if (fontValue) fontValue.value = "";
    if (textColorValue) textColorValue.value = "";
    if (symbolValue) symbolValue.value = "";
    if (symbolColorValue) symbolColorValue.value = "";
    if (flowerValue) flowerValue.value = "";

    root.querySelectorAll(".selected").forEach((el) => {
      el.classList.remove("selected");
    });

    [
      "lettre-fleurie",
      "police",
      "couleur-texte",
      "symbole",
      "couleur-symbole",
      "commentaire"
    ].forEach((name) => {
      const step = getStep(name);
      if (step) step.classList.remove("completed");
    });
  }

  function setTechnique(technique) {
    currentTechnique = technique;

    updateDisplayedPrice();

    techniqueValue.value =
      technique === "broderie"
        ? "Broderie"
        : "Flocage";

    resetAfterTechnique();

    /*
     * POLICES
     */
    renderFonts(technique);

    /*
     * COULEUR DU TEXTE
     */
    renderColors(
      textColorsContainer,
      textColorValue,
      technique,
      "couleur-texte",
      "symbole"
    );

    const hasProductFont =
      typeof window.MIMI_PRODUCT_FONT === "string" &&
      window.MIMI_PRODUCT_FONT.trim() !== "";

    /*
     * ARTICLE AVEC POLICE IMPOSÉE
     */
    if (hasProductFont) {

      showStep("symbole", false);
      showStep("couleur-symbole", false);
      showStep("lettre-fleurie", false);

      if (symbolValue) {
        symbolValue.value = "Aucun symbole";
      }

      if (symbolColorValue) {
        symbolColorValue.value = "";
      }

    } else {

      /*
       * PRODUITS NORMAUX
       */
      renderSymbols(technique);

      /*
       * CORRECTION :
       * chargement des couleurs des symboles
       */
      renderColors(
        symbolColorsContainer,
        symbolColorValue,
        technique,
        "couleur-symbole",
        "commentaire"
      );

      showStep("symbole", true);
      showStep("couleur-symbole", false);

      showStep(
        "lettre-fleurie",
        technique === "broderie"
      );
    }

    root.querySelectorAll("[data-technique]").forEach((btn) => {
      btn.classList.toggle(
        "selected",
        btn.dataset.technique === technique
      );
    });

    completeStep("technique");

    if (
      textInput &&
      textInput.value.trim().length > 0
    ) {
      goAfterText();
    } else {
      forceOpenMainSteps();
    }
  }

  function goAfterText() {
    completeStep("texte");

    const hasProductFont =
      typeof window.MIMI_PRODUCT_FONT === "string" &&
      window.MIMI_PRODUCT_FONT.trim() !== "";

    if (
      currentTechnique === "broderie" &&
      !hasProductFont
    ) {
      openStep("lettre-fleurie");
    } else {
      openStep("police");
    }
  }

  function renderFonts(technique) {
    fontsContainer.innerHTML = "";

    let fonts =
      MIMI_CONFIG.fonts[technique] || [];

    const hasProductFont =
      typeof window.MIMI_PRODUCT_FONT === "string" &&
      window.MIMI_PRODUCT_FONT.trim() !== "";

    if (hasProductFont) {
      fonts = [
        {
          name: "Pusher",
          image: window.MIMI_PRODUCT_FONT
        }
      ];
    }

    fonts.forEach((font) => {
      const button = document.createElement("button");

      button.type = "button";
      button.className = "mimi-image-choice";

      button.innerHTML = `
        <img
          src="${font.image}"
          alt="${font.name}"
          loading="lazy"
        >
        <span>${font.name}</span>
      `;

      button.addEventListener("click", function () {
        fontsContainer
          .querySelectorAll(".mimi-image-choice")
          .forEach((el) => {
            el.classList.remove("selected");
          });

        button.classList.add("selected");
        fontValue.value = font.name;

        completeStep("police");
        openStep("couleur-texte");
      });

      fontsContainer.appendChild(button);
    });
  }

  function renderSymbols(technique) {
    symbolsContainer.innerHTML = "";

    const symbols =
      MIMI_CONFIG.symbols[technique] || [];

    symbols.forEach((symbol) => {
      const button = document.createElement("button");

      button.type = "button";
      button.className =
        "mimi-image-choice mimi-symbol-choice";

      button.innerHTML = `
        <img
          src="${symbol.image}"
          alt="${symbol.name}"
          loading="lazy"
        >
        <span>${symbol.name}</span>
      `;

      button.addEventListener("click", function () {
        symbolsContainer
          .querySelectorAll(".mimi-image-choice")
          .forEach((el) => {
            el.classList.remove("selected");
          });

        button.classList.add("selected");
        symbolValue.value = symbol.name;

        completeStep("symbole");

        if (symbol.name === "Aucun symbole") {
          symbolColorValue.value = "";

          completeStep("couleur-symbole");

          showStep(
            "couleur-symbole",
            false
          );

          openStep("commentaire");

        } else {
          showStep(
            "couleur-symbole",
            true
          );

          openStep("couleur-symbole");
        }
      });

      symbolsContainer.appendChild(button);
    });
  }

  /*
   * =========================================================
   * COULEURS
   * =========================================================
   *
   * Fonction originale conservée.
   */
  function renderColors(
    container,
    hiddenInput,
    technique,
    currentStep,
    nextStep
  ) {
    container.innerHTML = "";

    const colors =
      MIMI_CONFIG.colors[technique] || [];

    colors.forEach((color) => {
      const button =
        document.createElement("button");

      button.type = "button";
      button.className =
        "mimi-color-choice";

      button.title = color.name;

      button.setAttribute(
        "aria-label",
        color.name
      );

      /*
       * IMPORTANT :
       * On conserve exactement le fonctionnement
       * visuel d'origine.
       */
      if (color.image) {
        button.innerHTML = `
          <img
            src="${color.image}"
            alt="${color.name}"
            loading="lazy"
          >
          <span>${color.name}</span>
        `;
      } else {
        button.style.backgroundColor =
          color.value;

        button.innerHTML =
          `<span>${color.name}</span>`;
      }

      button.addEventListener(
        "click",
        function () {

          container
            .querySelectorAll(
              ".mimi-color-choice"
            )
            .forEach((el) => {
              el.classList.remove(
                "selected"
              );
            });

          button.classList.add(
            "selected"
          );

          hiddenInput.value =
            color.name;

          completeStep(
            currentStep
          );

          openStep(nextStep);
        }
      );

      container.appendChild(button);
    });
  }

  /*
   * =========================================================
   * ACCORDÉONS
   * =========================================================
   */

  root
    .querySelectorAll(
      ".mimi-accordion-title"
    )
    .forEach((title) => {

      title.addEventListener(
        "click",
        function () {

          const step =
            title.closest(
              ".mimi-accordion"
            );

          const stepName =
            step.dataset.step;

          if (
            stepName === "technique" ||
            stepName === "texte"
          ) {

            step.classList.add(
              "active"
            );

            const toggle =
              step.querySelector(
                ".mimi-toggle"
              );

            if (toggle) {
              toggle.textContent = "−";
            }

            return;
          }

          const isActive =
            step.classList.contains(
              "active"
            );

          steps.forEach((item) => {

            const itemName =
              item.dataset.step;

            if (
              itemName === "technique" ||
              itemName === "texte"
            ) {
              return;
            }

            item.classList.remove(
              "active"
            );

            const toggle =
              item.querySelector(
                ".mimi-toggle"
              );

            if (toggle) {
              toggle.textContent = "+";
            }
          });

          if (!isActive) {

            step.classList.add(
              "active"
            );

            const toggle =
              step.querySelector(
                ".mimi-toggle"
              );

            if (toggle) {
              toggle.textContent = "−";
            }
          }

          forceOpenMainSteps();
        }
      );
    });

  /*
   * =========================================================
   * TECHNIQUES
   * =========================================================
   */

  root
    .querySelectorAll("[data-technique]")
    .forEach((button) => {

      button.addEventListener(
        "click",
        function () {
          setTechnique(
            button.dataset.technique
          );
        }
      );
    });

  /*
   * =========================================================
   * TEXTE
   * =========================================================
   */

  if (textInput) {

    textInput.addEventListener(
      "input",
      function () {

        const length =
          textInput.value.length;

        if (textCount) {
          textCount.textContent =
            length;
        }

        if (
          length > 0 &&
          currentTechnique
        ) {
          goAfterText();
        }
      }
    );
  }

  /*
   * =========================================================
   * LETTRE FLEURIE
   * =========================================================
   */

  root
    .querySelectorAll("[data-flower]")
    .forEach((button) => {

      button.addEventListener(
        "click",
        function () {

          root
            .querySelectorAll(
              "[data-flower]"
            )
            .forEach((el) => {
              el.classList.remove(
                "selected"
              );
            });

          button.classList.add(
            "selected"
          );

          flowerValue.value =
            button.dataset.flower;

          completeStep(
            "lettre-fleurie"
          );

          openStep("police");
        }
      );
    });

  /*
   * =========================================================
   * INITIALISATION
   * =========================================================
   */

  showStep(
    "lettre-fleurie",
    false
  );

  showStep(
    "couleur-symbole",
    false
  );

  forceOpenMainSteps();

  /*
   * =========================================================
   * FLOQUAGE UNIQUEMENT
   * =========================================================
   */

  if (mode === "flocage") {

    if (techniqueChoices) {
      techniqueChoices.style.display =
        "none";
    }

    if (techniqueAuto) {
      techniqueAuto.innerHTML =
        "<strong>✓ Flocage</strong><br>" +
        "<small>Cet article est disponible uniquement en flocage.</small>";
    }

    setTechnique("flocage");
  }

  /*
   * =========================================================
   * BRODERIE UNIQUEMENT
   * =========================================================
   */

  else if (mode === "broderie") {

    if (techniqueChoices) {
      techniqueChoices.style.display =
        "none";
    }

    if (techniqueAuto) {
      techniqueAuto.innerHTML =
        "<strong>✓ Broderie <br>+5€</strong><br>" +
        "<small>Cet article est disponible uniquement en broderie.</small>";
    }

    setTechnique("broderie");
  }

  /*
   * =========================================================
   * FLOQUAGE + BRODERIE
   * =========================================================
   */

  else {
    forceOpenMainSteps();
  }

});